import * as React from 'react';
import { IClientOrderData } from '../../../types/clientPortal/IClientOrderData';
import { ClientOrderPageHeader } from './ClientOrderPageHeader';
import { determineOrderDetailsData } from '../../../utilities/clientPortal/determineOrderDetailsData';

export interface IClientOrderHeaderApp {
  showSub?: boolean;
  order?: IClientOrderData;
  children?: React.ReactNode;
}

const ClientOrderHeaderApp: React.FC<IClientOrderHeaderApp> = ({ showSub = true, order, children }) => {
  const orderData = determineOrderDetailsData({ order });

  return (
    <>
      {order && (
        <ClientOrderPageHeader order={orderData} showSub={showSub} creator={order.creator.name}>
          {children}
        </ClientOrderPageHeader>
      )}
    </>
  );
};

export default ClientOrderHeaderApp;
